<ng-template #content><ng-content /></ng-template>

<div [class]="cellClasses()">
    @if (disabled()) {
        <span class="relative z-10"> <ng-container *ngTemplateOutlet="content" /></span>
    } @else {
        <ng-container *ngTemplateOutlet="content" />
    }
</div>
